import { render, staticRenderFns } from "./AppCardActions.vue?vue&type=template&id=15957d52"
import script from "./AppCardActions.vue?vue&type=script&lang=js"
export * from "./AppCardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports